import User from "../../../apis/User";
import Permissions from "../../../apis/Permissions";
import router from "../../../router";

const state = {
    permissions: [],
    permissionError: ""
};

const getters = {};

const actions = {
    getAllPermissions({ commit }) {
        return new Promise((resolve, reject) => {
            Permissions.index()
                .then((response) => {
                    resolve(response.data.data[0]);
                    commit("GET_ALL_PERMISSIONS", response.data.data[0])
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("GET_ALL_PERMISSIONS", []);
                        commit("DETECT_PERMISSION_ERROR", error.response);
                    }
                })
        });
    },
    getPermission({ commit }, id) {
        return new Promise((resolve, reject) => {
            Permissions.show(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("GET_PERMISSION", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_PERMISSION_ERROR", error.response);
                    }
                })
        })
    },
    createPermission({ commit }, obj) {
        return new Promise((resolve, reject) => {
            Permissions.store(obj)
                .then((response) => {
                    resolve(response.data.data);

                    commit("CREATE_PERMISSION", response.data.data);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_PERMISSION_ERROR", error.response);
                    }
                })
        })
    },
    updatePermission({ commit }, { id, obj }) {
        return new Promise((resolve, reject) => {
            Permissions.update(id, obj)
                .then((response) => {
                    resolve(response.data.data);
                    commit("UPDATE_PERMISSION", obj);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_PERMISSION_ERROR", error.response);
                    }
                })
        })
    },
    removePermission({ commit }, id) {
        return new Promise((resolve, reject) => {
            Permissions.delete(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("REMOVE_PERMISSION", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_PERMISSION_ERROR", error.response);
                    }
                })
        })
    }
};

const mutations = {
    GET_ALL_PERMISSIONS(state, response) {
        state.permissions = response;
    },
    GET_PERMISSION(state, id) {

    },
    CREATE_PERMISSION(state, obj) {
        state.permissions.push(obj);
    },
    UPDATE_PERMISSION(state, obj) {
        let objIndexToUpdate = state.permissions.findIndex(el => el.id === obj.id);
        state.permissions[objIndexToUpdate] = obj;
    },
    REMOVE_PERMISSION(state, id) {
        let objIndexToDelete = state.permissions.findIndex(el => el.id === id);
        state.permissions.splice(objIndexToDelete, 1);
    },
    DETECT_PERMISSION_ERROR(state, error) {
        setTimeout(() => {
            state.permissionError = "";
        }, 1000)

        if (error.status == 401 || error.status == 419) {
            User.logout().then(() => {
                localStorage.removeItem("auth");
                router.push({ name: "Login", path: router.currentRoute.path });
            })
        } else if (error.data.message !== undefined) {
            state.permissionError = error.data.message;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}